import type { ReactNode } from 'react';

import ArrowRightLine from '@/assets/icons/arrow_right_line.svg?component';
import TrendingDownFill from '@/assets/icons/trending_down_fill.svg?component';
import TrendingUpFill from '@/assets/icons/trending_up_fill.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { TrendIconEnum } from '@/components/atoms/TrendIcon/TrendIconUtils';

import type { HealthAlertDisplayLevel } from '../HealthDashboard/healthAlertDisplay';
import type { HealthParameterDevelopmentLevel } from '../HealthDashboard/healthParameterMetricDisplay';

export const HEALTH_ALERT_LEVEL_ICON_SIZE = 16;
export const HEALTH_ALERT_TREND_ICON_SIZE = 20;

export function getHealthAlertTrendColor(displayLevel: HealthAlertDisplayLevel): string {
    switch (displayLevel) {
        case 'high':
            return 'var(--tint-red-fg)';
        case 'medium':
            return 'var(--tint-orange-fg)';
        case 'low':
            return 'var(--tint-yellow-fg)';
    }
}

/** Arrow matches development label: decreasing → down; stable → flat; increasing tiers → up. */
export function resolveHealthParameterTrendFromDevelopment(
    development: HealthParameterDevelopmentLevel
): TrendIconEnum {
    switch (development) {
        case 'rapidlyIncreasing':
        case 'increasing':
            return TrendIconEnum.TrendNegativeUp;
        case 'decreasing':
            return TrendIconEnum.TrendNegativeDown;
        case 'stable':
            return TrendIconEnum.TrendStable;
    }
}

export function renderHealthParameterTrendIcon(
    trend: TrendIconEnum,
    color: string,
    iconSize: number = HEALTH_ALERT_TREND_ICON_SIZE
): ReactNode {
    switch (trend) {
        case TrendIconEnum.TrendNegativeUp:
            return (
                <SvgIcon icon={TrendingUpFill} size="custom" customSize={iconSize} color={color} />
            );
        case TrendIconEnum.TrendNegativeDown:
            return (
                <SvgIcon
                    icon={TrendingDownFill}
                    size="custom"
                    customSize={iconSize}
                    color={color}
                />
            );
        case TrendIconEnum.TrendStable:
            return (
                <SvgIcon icon={ArrowRightLine} size="custom" customSize={iconSize} color={color} />
            );
        default:
            return null;
    }
}

/** Detail panel stable trend (horizontal arrow). */
export const HEALTH_DETAIL_STABLE_TREND_COLOR = 'var(--color-text-secondary)';
